import React from 'react';
import './ErrorMessage.css';

function ErrorMessage({ message }) {
    if (!message) return null;

    return (
        <div className="error-message">
            <i className="fas fa-exclamation-circle"></i>
            <span>{message}</span>
        </div>
    );
}

export default ErrorMessage; 